import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
const DebutLifeCarsoul = dynamic(() => import('@/components/Ui-components/DebutLifeCarsoul'), {ssr: false});

const DebutLife = (props: any) => {
    const {carsoulheading, carsoulsubheading} = props;
    return (
        <MUIBox className="employee-feedback-wrapper">
            <MUIContainer className="top-spacing">
                <MUIBox className="spectrum-header-wrapper solutions">
                    <MUITypography className="spectrum-heading top-space color-black">{carsoulheading}</MUITypography>
                    <MUIBox className="divder-wrapper">
                        <hr className="divider-line" />
                    </MUIBox>
                    {carsoulsubheading && (
                        <MUIBox className="sub-heading-box">
                            <MUITypography className="spectrum-sub-heading color-black">{carsoulsubheading}</MUITypography>
                        </MUIBox>
                    )}
                </MUIBox>
            </MUIContainer>
            <MUIBox className="blackchain-benefits-icons top-spacing">
                <DebutLifeCarsoul />
            </MUIBox>
        </MUIBox>
    );
};

export default memo(DebutLife);
